import {useEffect} from 'react';
import {createRoot, Root} from 'react-dom/client';
import {requestContext} from '../../../../../../common/requestContext';
import {ViewerGuide} from '../../../../../../design-system/organisms/ViewerGuide/ViewerGuide';
import {ViewerGuideType} from '../../../../../../design-system/organisms/ViewerGuide/ViewerGuideType.enum';
import {
  VIEWER_GUIDE_FADE_IN_MS,
  VIEWER_GUIDE_WRAPPER_ID,
} from '../constant/viewerGuideConstant';

let toastTimerId: NodeJS.Timeout | null = null;
let rootContainer: Root | null;

export function showViewerGuide({
  viewerGuideType,
  delayMs = 1000,
}: {
  viewerGuideType: ViewerGuideType | undefined;
  delayMs?: number;
}) {
  const {isWebView} = requestContext.requestInfo.display;

  if (toastTimerId) {
    clearTimeout(toastTimerId);
  }
  removeViewerGuide();

  // 웹뷰로 뜬 경우는 뷰잉모드 가이드를 앱에서 띄워주므로 웹뷰가 아닐 때에만 토스트 사용.
  if (isWebView || viewerGuideType === undefined) return null;

  const container = createViewerGuideWrapperDiv();
  rootContainer = createRoot(container);
  rootContainer.render(
    <ViewerGuideContainer
      callback={() => {
        toastTimerId = setTimeout(() => {
          const toastContainer = document.getElementById(
            VIEWER_GUIDE_WRAPPER_ID
          );
          if (toastContainer) {
            toastContainer.style.transition = 'opacity 0.3s';
            toastContainer.style.opacity = '0';
            // transition이 끝나기 전에 toastContainer가 제거되었다면, 삭제 로직을 수행하지 않습니다.
            toastContainer.ontransitionend = () => removeViewerGuide();
          }
        }, delayMs + VIEWER_GUIDE_FADE_IN_MS);
      }}
      viewerGuideType={viewerGuideType}
    />
  );
}

function ViewerGuideContainer({
  callback,
  viewerGuideType,
}: {
  callback: VoidFunction;
  viewerGuideType: ViewerGuideType;
}) {
  useEffect(() => {
    callback();
  }, [callback]);

  return (
    <div className="pointer-events-none z-100 flex h-full w-full animate-fade-in flex-row justify-center bg-transparent">
      <div className="self-center">
        <ViewerGuide viewerGuideType={viewerGuideType} />
      </div>
    </div>
  );
}

function createViewerGuideWrapperDiv() {
  const container = document.createElement('div');
  container.id = VIEWER_GUIDE_WRAPPER_ID;
  container.style.cssText =
    'position: fixed; top: 0px; left: 0px; z-index: 100; width: 100%; height: 100%; pointer-events: none; height: fill-available; height: -webkit-fill-available';
  document.body.appendChild(container);
  return container;
}

function removeViewerGuide() {
  const viewerGuideContainer = document.getElementById(VIEWER_GUIDE_WRAPPER_ID);
  if (viewerGuideContainer) {
    if (rootContainer) {
      rootContainer.unmount();
      rootContainer = null;
    }
    viewerGuideContainer.parentNode?.removeChild(viewerGuideContainer);
  }
}
